<template>
  <ExActionsPopUp
    :value="show"
    headline="Archive Department"
    :icon="'department_icon'"
    :htmlInfo="info"
    :destructive="true"
    actionLabel="Archive"
    :centerHeadline="true"
    actionsTopSpacing="32px"
    @onAction="$emit('onArchive')"
    @input="$emit('onClose')"
    data-testid="archive-department-popup"
    :applyBorderClass="true"
    :width="450"
  >
  </ExActionsPopUp>
</template>
<script setup>
import { computed } from "vue";
import ExActionsPopUp from "@components/common/ExActionsPopUp.vue";

const props = defineProps({
  show: {
    type: Boolean, 
    default: false,
  },
  name: {
    type: String,
    default: "",
  },
});

defineEmits(["onArchive", "onClose"]);

const formattedInfo = computed(() => {
  return `<div style="max-width: 414px; margin: 0 auto; margin-top: 26px;">Department ${props.name} is about to be archived.</div>`;
});

const info = computed(() => {
  return formattedInfo.value;
});
</script>
